/**
 * Workspace tabs. `value` is the `/workspace/:tab` segment.
 */
export const WORKSPACE_TABS = [
  {
    value: 'branding',
    label: 'Branding',
    title: 'Branding',
    subtitle: 'Logo, colors and typography used across the portal.',
  },
  {
    value: 'members',
    label: 'Members',
    title: 'Members',
    subtitle: 'Who can edit, publish and manage this workspace.',
    // Renders its own head (the Invite member button sits next to it).
    ownHead: true,
  },
  {
    value: 'custom-domain',
    label: 'Custom domain',
    title: 'Custom domain',
    subtitle: 'Serve your portal from your own domain.',
  },
  // White label email stays per learning path (Settings › White labeling) in
  // phase 1; `email-tab.js` is the later workspace-level design.
  {
    value: 'language',
    label: 'Language',
    title: 'Language',
    subtitle: 'Default language and built-in texts for each language.',
  },
  {
    value: 'integrations',
    label: 'Integrations',
    title: 'Integrations',
    subtitle: 'Connect Mini Course Generator to the tools you already use.',
  },
  {
    value: 'settings',
    label: 'Settings',
    title: 'Workspace settings',
    subtitle: 'Name and details for this workspace.',
  },
]

export const workspacePath = tab => `/workspace/${tab}`

/** Older standalone pages that now open a workspace tab. */
const LEGACY_PATHS = {
  '/workspace/roles': 'members',
  '/workspace/webhooks': 'integrations',
  '/workspace/api-keys': 'integrations',
  '/custom-domain': 'custom-domain',
  '/automations': 'integrations',
}

/** Resolves the active tab from the URL. */
export const tabFromPath = pathname => {
  const path = pathname.replace(/\/+$/, '')
  if (LEGACY_PATHS[path]) return LEGACY_PATHS[path]
  const segment = path.split('/')[2]
  return WORKSPACE_TABS.some(tab => tab.value === segment)
    ? segment
    : WORKSPACE_TABS[0].value
}

/** Route pattern for the workspace page (keeps the invite route free). */
export const WORKSPACE_ROUTE = `/workspace/:tab(${WORKSPACE_TABS.map(
  tab => tab.value,
).join('|')})`
